import { v4 as uuidv4 } from 'uuid';

export const categoryDataList = [
  // 問題１
  {
    id: '5b44ecfa-ebed-423f-bad6-catergory100',
    no: 1,
    description: '加算の問題です。',
    time_limit: 600000,
  },
  // 問題２
  {
    id: '5b44ecfa-ebed-423f-bad6-catergory200',
    no: 2,
    description: '減算の問題です。',
    time_limit: 600000,
  },
  // 問題３
  {
    id: '5b44ecfa-ebed-423f-bad6-catergory300',
    no: 3,
    description: '乗算の問題です。',
    time_limit: 1200000,
  },
  // 問題４
  {
    id: '5b44ecfa-ebed-423f-bad6-catergory400',
    no: 4,
    description: '除算の問題です。',
    time_limit: 1200000,
  },
  // 問題５
  {
    id: '5b44ecfa-ebed-423f-bad6-catergory500',
    no: 5,
    description: '四則演算の問題です。',
    time_limit: 1800000,
  },
];

export const quizDataList = [
  {
    id: '5b44ecfa-ebed-423f-prac-quiz10000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '2 + 3 = □',
    answer: '5',
    practice_flg: 1,
  },
  {
    id: '5b44ecfa-ebed-423f-prac-quiz10000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '1 + 3 + 5 = □',
    answer: '9',
    practice_flg: 1,
  },

  {
    id: '5b44ecfa-ebed-423f-test-quiz10000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '1 + 6 = □',
    answer: '7',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '5 + 9 = □',
    answer: '14',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000003',
    no: 3,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '7 + 3 = □',
    answer: '10',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000004',
    no: 4,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '4 + 7 = □',
    answer: '11',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000005',
    no: 5,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '8 + 7 = □',
    answer: '15',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000006',
    no: 6,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '12 + 12 = □',
    answer: '24',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000007',
    no: 7,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '32 + 6 = □',
    answer: '38',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000008',
    no: 8,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '9 + 76 = □',
    answer: '85',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000009',
    no: 9,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '48 + 33 = □',
    answer: '81',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000010',
    no: 10,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '25 + 17 = □',
    answer: '42',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000011',
    no: 11,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '35 + 65 = □',
    answer: '100',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000012',
    no: 12,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '86 + 73 = □',
    answer: '159',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000013',
    no: 13,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '92 + 84 = □',
    answer: '176',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000014',
    no: 14,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '27 + 134 = □',
    answer: '161',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000015',
    no: 15,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '127 + 67 = □',
    answer: '194',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000016',
    no: 16,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '7 + 9 + 5 = □',
    answer: '21',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000017',
    no: 17,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '26 + 7 + 54 = □',
    answer: '87',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000018',
    no: 18,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '43 + 17 + 68 = □',
    answer: '128',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000019',
    no: 19,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '76 + 49 + 80 = □',
    answer: '205',
    points: 2,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz10000020',
    no: 20,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory100',
    question: '163 + 271 + 26 = □',
    answer: '460',
    points: 2,
    practice_flg: 0,
  },
  // 問題２
  {
    id: '5b44ecfa-ebed-423f-prac-quiz20000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '8 - 3 = □',
    answer: '5',
    practice_flg: 1,
  },
  {
    id: '5b44ecfa-ebed-423f-prac-quiz20000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '9 - 7 = □',
    answer: '2',
    practice_flg: 1,
  },

  {
    id: '5b44ecfa-ebed-423f-test-quiz20000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '5 - 4 = □',
    answer: '1',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '7 - 3 = □',
    answer: '4',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000003',
    no: 3,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '6 - 6 = □',
    answer: '0',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000004',
    no: 4,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '14 - 3 = □',
    answer: '11',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000005',
    no: 5,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '12 - 7 = □',
    answer: '5',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000006',
    no: 6,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '18 - 9 = □',
    answer: '9',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000007',
    no: 7,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '24 - 11 = □',
    answer: '13',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000008',
    no: 8,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '31 - 28 = □',
    answer: '3',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000009',
    no: 9,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '28 - 7 = □',
    answer: '21',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000010',
    no: 10,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '36 - 27 = □',
    answer: '9',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000011',
    no: 11,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '58 - 16 = □',
    answer: '42',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000012',
    no: 12,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '70 - 14 = □',
    answer: '56',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000013',
    no: 13,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '64 - 57 = □',
    answer: '7',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000014',
    no: 14,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '85 - 12 = □',
    answer: '73',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000015',
    no: 15,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '93 - 46 = □',
    answer: '47',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000016',
    no: 16,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '471 - 23 - 52 = □',
    answer: '396',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000017',
    no: 17,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '298 - 50 - 89 = □',
    answer: '159',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000018',
    no: 18,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '711 - 194 - 424 = □',
    answer: '93',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000019',
    no: 19,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '586 - 479 - 85 = □',
    answer: '22',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz20000020',
    no: 20,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory200',
    question: '860 - 507 - 346 = □',
    answer: '7',
    points: 1,
    practice_flg: 0,
  },
  // 問題３
  {
    id: '5b44ecfa-ebed-423f-prac-quiz30000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '1 × 3 = □',
    answer: '3',
    practice_flg: 1,
  },
  {
    id: '5b44ecfa-ebed-423f-prac-quiz30000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '5 × 5 = □',
    answer: '25',
    practice_flg: 1,
  },

  {
    id: '5b44ecfa-ebed-423f-test-quiz30000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '2 × 6 = □',
    answer: '12',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '4 × 7 = □',
    answer: '28',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000003',
    no: 3,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '7 × 6 = □',
    answer: '42',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000004',
    no: 4,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '8 × 8 = □',
    answer: '64',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000005',
    no: 5,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '9 × 6 = □',
    answer: '54',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000006',
    no: 6,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '11 × 3 = □',
    answer: '33',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000007',
    no: 7,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '13 × 7 = □',
    answer: '91',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000008',
    no: 8,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '17 × 3 = □',
    answer: '51',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000009',
    no: 9,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '7 × 14 = □',
    answer: '98',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000010',
    no: 10,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '2 × 57 = □',
    answer: '114',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000011',
    no: 11,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '13 × 10 = □',
    answer: '130',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000012',
    no: 12,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '21 × 12 = □',
    answer: '252',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz30000013',
    no: 13,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '18 × 14 = □',
    answer: '252',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz300000014',
    no: 14,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '28 × 39 = □',
    answer: '1092',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz300000015',
    no: 15,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '47 × 96 = □',
    answer: '4512',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz300000016',
    no: 16,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '1 × 3 × 5 = □',
    answer: '15',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz300000017',
    no: 17,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '7 × 9 × 4 = □',
    answer: '252',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz300000018',
    no: 18,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '2 × 9 × 6 = □',
    answer: '108',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz300000019',
    no: 19,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '8 × 5 × 12 = □',
    answer: '480',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz300000020',
    no: 20,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory300',
    question: '42 × 9 × 17 = □',
    answer: '6426',
    points: 1,
    practice_flg: 0,
  },
  // 問題４
  {
    id: '5b44ecfa-ebed-423f-prac-quiz40000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '3 ÷ 3 = □',
    answer: '1',
    practice_flg: 1,
  },
  {
    id: '5b44ecfa-ebed-423f-prac-quiz40000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '8 ÷ 2 = □',
    answer: '4',
    practice_flg: 1,
  },

  {
    id: '5b44ecfa-ebed-423f-test-quiz40000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '6 ÷ 3 = □',
    answer: '2',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '9 ÷ 3 = □',
    answer: '3',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000003',
    no: 3,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '18 ÷ 3 = □',
    answer: '6',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000004',
    no: 4,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '30 ÷ 6 = □',
    answer: '5',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000005',
    no: 5,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '28 ÷ 2 = □',
    answer: '14',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000006',
    no: 6,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '40 ÷ 4 = □',
    answer: '10',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000007',
    no: 7,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '35 ÷ 5 = □',
    answer: '7',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000008',
    no: 8,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '16 ÷ 8 = □',
    answer: '2',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000009',
    no: 9,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '27 ÷ 9 = □',
    answer: '3',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000010',
    no: 10,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '81 ÷ 3 = □',
    answer: '27',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000011',
    no: 11,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '39 ÷ 13 = □',
    answer: '3',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000012',
    no: 12,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '92 ÷ 23 = □',
    answer: '4',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000013',
    no: 13,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '135 ÷ 27 = □',
    answer: '5',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000014',
    no: 14,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '78 ÷ 13 = □',
    answer: '6',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000015',
    no: 15,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '315 ÷ 45 = □',
    answer: '7',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000016',
    no: 16,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '284 ÷ 71 = □',
    answer: '4',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000017',
    no: 17,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '176 ÷ 16 = □',
    answer: '11',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000018',
    no: 18,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '372 ÷ 31 = □',
    answer: '12',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000019',
    no: 19,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '425 ÷ 25 = □',
    answer: '17',
    points: 1,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz40000020',
    no: 20,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory400',
    question: '507 ÷ 39 = □',
    answer: '13',
    points: 1,
    practice_flg: 0,
  },
  // 問題５
  {
    id: '5b44ecfa-ebed-423f-prac-quiz50000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '1 + 2 × 3 = □',
    answer: '7',
    practice_flg: 1,
  },
  {
    id: '5b44ecfa-ebed-423f-prac-quiz50000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '9 ÷ 3 + 2 = □',
    answer: '5',
    practice_flg: 1,
  },

  {
    id: '5b44ecfa-ebed-423f-test-quiz50000001',
    no: 1,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '10 - 4 + 4 = □',
    answer: '10',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000002',
    no: 2,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '3 + 24 - 9 = □',
    answer: '18',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000003',
    no: 3,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '45 + 11 - 50 = □',
    answer: '6',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000004',
    no: 4,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '23 - 65 + 72 = □',
    answer: '30',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000005',
    no: 5,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '74 + 7 - 68 = □',
    answer: '13',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000006',
    no: 6,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '81 - 27 - 36 = □',
    answer: '18',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000007',
    no: 7,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '21 + 47 + 36 = □',
    answer: '104',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000008',
    no: 8,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '56 - 74 + 88 = □',
    answer: '70',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000009',
    no: 9,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '71 + 68 - 90 = □',
    answer: '49',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000010',
    no: 10,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '96 - 240 + 158 = □',
    answer: '14',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000011',
    no: 11,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '2 × 3 + 7 × 4 = □',
    answer: '34',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000012',
    no: 12,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '9 × 5 - 60 ÷ 12 = □',
    answer: '40',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000013',
    no: 13,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '7 × 3 + 9 - 20 = □',
    answer: '10',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz500000014',
    no: 14,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '86 ÷ 2 × 3 = □',
    answer: '129',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz50000015',
    no: 15,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '49 - 21 ÷ 7 = □',
    answer: '46',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '6b44ecfa-ebed-423f-test-quiz50000016',
    no: 16,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '8 × 64 ÷ 8 = □',
    answer: '64',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz500000017',
    no: 17,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '1 + 7 × 8 ÷ 4 = □',
    answer: '15',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '5b44ecfa-ebed-423f-test-quiz500000018',
    no: 18,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '24 - 54 ÷ 9 × 4 = □',
    answer: '1',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '6b44ecfa-ebed-423f-test-quiz50000019',
    no: 19,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '29 + 42 × 3 - 30 = □',
    answer: '125',
    points: 3,
    practice_flg: 0,
  },
  {
    id: '6b44ecfa-ebed-423f-test-quiz50000020',
    no: 20,
    catergoryId: '5b44ecfa-ebed-423f-bad6-catergory500',
    question: '3 × 28 - 81 ÷ 9 = □',
    answer: '75',
    points: 3,
    practice_flg: 0,
  },
];
